module.exports = __webpack_public_path__ + "static/media/header-bg.dfcd7a28.jpg";